"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=isValueSelected;// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function isValueSelected(a,b){return void 0!==b&&void 0!==a&&(Array.isArray(b)?0<=b.indexOf(a):a===b)}